module.exports = __webpack_public_path__ + "img/email-task.76170a0b.svg";